import * as React from 'react'
import { Box, TextField, Typography } from '@mui/material'
import type { Dayjs } from 'dayjs'
import DatePickerField from '../../../components/UI/DatePickerField'

export interface ContractFormFieldsProps {
  contractNumber: string
  onContractNumberChange: (value: string) => void
  contractDate: Dayjs | string | null
  onContractDateChange: (value: string | null) => void
  contractSentDate: Dayjs | string | null
  onContractSentDateChange: (value: string | null) => void
  contractTrackingNumber: string
  onContractTrackingNumberChange: (value: string) => void
  disabled?: boolean
  required?: boolean
}

export default function ContractFormFields({
  contractNumber,
  onContractNumberChange,
  contractDate,
  onContractDateChange,
  contractSentDate,
  onContractSentDateChange,
  contractTrackingNumber,
  onContractTrackingNumberChange,
  disabled = false,
  required = false
}: ContractFormFieldsProps) {
  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Box display="flex" flexDirection="column">
        <Typography variant="subtitle1" color="black">
          Договор:
        </Typography>
        <Box display="flex" gap={1}>
          <Box sx={{ flex: 1 }}>
            <TextField
              fullWidth
              disabled={disabled}
              variant="outlined"
              label="Номер"
              value={contractNumber}
              onChange={(e) => onContractNumberChange(e.target.value)}
              required={required}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <DatePickerField
              label="Дата"
              value={contractDate}
              onChange={onContractDateChange}
              disabled={disabled}
              required={required}
            />
          </Box>
        </Box>
      </Box>

      <Box display="flex" flexDirection="column">
        <Typography variant="subtitle1" color="black">
          Отправка контрагенту:
        </Typography>
        <Box display="flex" gap={1}>
          <Box sx={{ flex: 1 }}>
            <DatePickerField
              label="Дата отправки контрагенту"
              value={contractSentDate}
              onChange={onContractSentDateChange}
              disabled={disabled}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <TextField
              fullWidth
              disabled={disabled}
              variant="outlined"
              label="№ ШПИ"
              value={contractTrackingNumber}
              onChange={(e) => onContractTrackingNumberChange(e.target.value)}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
